import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, mergeMap } from 'rxjs/operators';
import { BudgetsService } from '@appStore/contracts/services/budgets.service';

import * as budgetsActions from '@appStore/contracts/actions/budgets.actions';
import { BudgetsActionTypes } from '@appStore/contracts/actions/budgets.actions';

@Injectable()
export class BudgetsEffects {
  constructor(private budgetsService: BudgetsService, private actions$: Actions) {}

  budgetLoadData$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(BudgetsActionTypes.BudgetLoadData),
      map((action: budgetsActions.BudgetLoad) => action.payload),
      mergeMap(request => {
        return this.budgetsService.getBudget(request).pipe(
          map(item => new budgetsActions.BudgetLoadSuccess(item)),
          catchError(error => of(new budgetsActions.BudgetLoadFail(error)))
        );
      })
    );
  });
  progLoadData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(BudgetsActionTypes.PrognosisLoadData),
      map((action: budgetsActions.PrognosisLoad) => action.payload),
      mergeMap(request => {
        return this.budgetsService.getBudget(request).pipe(
          map(item => new budgetsActions.PrognosisLoadSuccess(item)),
          catchError(error => of(new budgetsActions.PrognosisLoadFail(error)))
        );
      })
    );
  });
}
